import React, { useState } from 'react';
import CandidateFilters from './CandidateFilters';
import Container from 'src/components/shared/Container';
import CandidatesHeader from './CandidatesHeader';
import CandidateList from './CandidateList';
import {
	useGetCampusHiringApplicationsWithCandidates,
	useGetCampusHiringCandidates,
} from 'src/hooks/campusHiring.hooks';
import { Spinner } from 'flowbite-react';
import CampusCandidateListingTabs from './CampusCandidateListingTabs';
import { CandidatesTabsEnum } from 'src/components/recruiterPositions/RecruiterCandidatesContainer2';
import { Zoom } from '@mui/material';
import { CampusUserWithApplication, TypeOfUsers } from 'types';
import { useSearchParams } from 'react-router-dom';
import classNames from 'classnames';
import PlacedLoadingAnimation from 'src/components/PlacedLoadingAnimation';
import NewCreatingPositionLoader from 'src/components/position/NewCreatingPositionLoader';

const CampusCandidateListing = () => {
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [searchParams, setSearchParams] = useSearchParams();
	const search = searchParams.get('search') || '';
	const defaultTab = searchParams.get('tab') || '';
	const [tab, setTab] = useState((defaultTab as CandidatesTabsEnum) || CandidatesTabsEnum.RECOMMENDATIONS);
	const [bulkSelectedCandidates, setBulkSelectedCandidates] = React.useState<string[]>([]);

	const { data, isLoading } = useGetCampusHiringCandidates({
		page,
		limit: rowsPerPage,
		filters: {
			sortBy: searchParams.get('sortBy') || 'bestMatch',
			roles: JSON.parse(searchParams.get('role') || '[]'),
			campus: JSON.parse(searchParams.get('campus') || '[]'),
			skills: JSON.parse(searchParams.get('skills') || '[]'),
			salary: JSON.parse(searchParams.get('salary') || '[]'),
			locations: JSON.parse(searchParams.get('location') || '[]'),
			expectedJoining: JSON.parse(searchParams.get('availability') || '[]'),
		},
	});

	const {
		data: applicationsData,
		isLoading: applicationLoading,
		isFetching: applicationFetching,
	} = useGetCampusHiringApplicationsWithCandidates({
		page,
		search: search,
		limit: rowsPerPage,
		onComplete: data => {
			if (data?.total === 0 && tab !== CandidatesTabsEnum.RECOMMENDATIONS) {
				setSearchParams({ tab: CandidatesTabsEnum.RECOMMENDATIONS });
			}
		},
	});

	const totalShortlistedCandidates = applicationsData?.total || 0;

	return (
		<Container>
			<div className="">
				<CandidatesHeader
					extraContent={
						tab === CandidatesTabsEnum.RECOMMENDATIONS ? (
							<div className="xl:hidden">
								<CandidateFilters
									selectedTab={tab}
									showCampusFilter={true}
									resetPage={() => setPage(0)}
									typeOfUsers={TypeOfUsers.CAMPUS}
									bulkSelectedCandidates={bulkSelectedCandidates}
									setBulkSelectedCandidates={setBulkSelectedCandidates}
									isApplicationApiLoading={applicationLoading || applicationFetching}
									candidates={
										(tab === CandidatesTabsEnum.RECOMMENDATIONS
											? data?.campusHiringCandidates
											: applicationsData?.campusHiringApplications) || []
									}
								/>
							</div>
						) : null
					}
				/>
			</div>
			<Zoom in={!!totalShortlistedCandidates || (!!totalShortlistedCandidates && !!search)} unmountOnExit>
				<div className="mt-[10px] pb-[6px] w-full md:max-w-[558px]">
					<CampusCandidateListingTabs
						tab={tab}
						setTab={setTab}
						onChange={data => {
							setPage(0);
							setBulkSelectedCandidates([]);
							setSearchParams({ tab: data });
						}}
						isTourActive={false}
						totalConections={totalShortlistedCandidates}
					/>
				</div>
			</Zoom>
			<div className={classNames('mt-[10px]', tab === CandidatesTabsEnum.RECOMMENDATIONS ? 'hidden xl:block' : '')}>
				<CandidateFilters
					selectedTab={tab}
					showCampusFilter={true}
					resetPage={() => setPage(0)}
					typeOfUsers={TypeOfUsers.CAMPUS}
					bulkSelectedCandidates={bulkSelectedCandidates}
					setBulkSelectedCandidates={setBulkSelectedCandidates}
					isApplicationApiLoading={applicationLoading || applicationFetching}
					candidates={
						(tab === CandidatesTabsEnum.RECOMMENDATIONS
							? data?.campusHiringCandidates
							: applicationsData?.campusHiringApplications) || []
					}
				/>
			</div>
			{isLoading || applicationLoading ? (
				<div className="mt-[22px] flex items-center justify-center h-[50vh]">
					{/* <Spinner /> */}
					<NewCreatingPositionLoader showAnimation={true} progressBar={false} customClassCss="!w-[30%] mx-auto " />
				</div>
			) : (
				<div className="mt-[22px] pb-5">
					<CandidateList
						page={page}
						setPage={setPage}
						selectedTab={tab}
						typeOfUsers={TypeOfUsers.CAMPUS}
						count={(tab === CandidatesTabsEnum.RECOMMENDATIONS ? data?.total : applicationsData?.total) || 0}
						rowsPerPage={rowsPerPage}
						setRowsPerPage={setRowsPerPage}
						bulkSelectedCandidates={bulkSelectedCandidates}
						setBulkSelectedCandidates={setBulkSelectedCandidates}
						candidates={
							(tab === CandidatesTabsEnum.RECOMMENDATIONS
								? data?.campusHiringCandidates
								: applicationsData?.campusHiringApplications) || []
						}
						totalShortlistedCandidates={totalShortlistedCandidates}
					/>
				</div>
			)}
		</Container>
	);
};

export default CampusCandidateListing;
